/* Session Engine — shared session picker (date strip + slots + inline question).
   Used by the product widget (all modes) and the Buy Now gate dialog.
   window.SEPicker.mount(container, data, { onConfirm, autoSelectDay, confirmLabel }) */
(function () {
  if (window.SEPicker) return;

  var CSS = [
    ".sep{font-family:inherit;color:#17201c}",
    ".sep-head{display:flex;align-items:baseline;gap:10px;margin:0 0 12px}",
    ".sep-title{font-weight:700;font-size:16px;margin:0}",
    ".sep-count{font-size:12px;color:#8a948e}",
    ".sep-striprow{position:relative}",
    ".sep-strip{display:flex;gap:9px;overflow-x:auto;padding:2px 2px 12px;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch}",
    ".sep-strip::-webkit-scrollbar{display:none}",
    ".sep-fade{position:absolute;top:0;right:0;bottom:10px;width:56px;background:linear-gradient(90deg,transparent,#fff 80%);pointer-events:none}",
    ".sep-pad{position:absolute;top:50%;transform:translateY(-60%);width:34px;height:34px;border-radius:50%;border:1px solid #dfe5e1;background:#fff;box-shadow:0 2px 10px rgba(20,30,25,.12);cursor:pointer;font-size:15px;color:#17201c;display:none;align-items:center;justify-content:center;z-index:2}",
    "@media(hover:hover){.sep-pad{display:flex}}",
    ".sep-pad.prev{left:-8px}.sep-pad.next{right:-8px}",
    ".sep-pad:disabled{opacity:0;pointer-events:none}",
    ".sep-day{flex:none;scroll-snap-align:start;width:72px;border:1.5px solid #e2e8e4;border-radius:14px;background:#fff;padding:10px 6px 9px;text-align:center;cursor:pointer;font:inherit;transition:border-color .12s,transform .12s,box-shadow .12s}",
    ".sep-day:hover{border-color:#28282c;transform:translateY(-1px)}",
    ".sep-day span{display:block;font-size:10px;color:#8a948e;text-transform:uppercase;letter-spacing:.08em;font-weight:700}",
    ".sep-day b{display:block;font-size:19px;line-height:1.25;font-weight:800}",
    ".sep-day i{display:block;font-style:normal;font-size:10px;color:#8a948e;text-transform:uppercase;letter-spacing:.08em;font-weight:600}",
    ".sep-day em{display:block;font-style:normal;font-size:9.5px;color:#b45309;font-weight:700;margin-top:3px}",
    ".sep-day[aria-pressed=true]{border-color:#28282c;background:#28282c;color:#fff;box-shadow:0 6px 16px -6px rgba(40,40,44,.35)}",
    ".sep-day[aria-pressed=true] span,.sep-day[aria-pressed=true] i{color:rgba(255,255,255,.75)}",
    ".sep-day[aria-pressed=true] em{color:#ffd9a8}",
    ".sep-times-label{font-size:12px;font-weight:700;color:#4e5c55;margin:2px 0 8px}",
    ".sep-slots{display:flex;gap:8px;flex-wrap:wrap}",
    ".sep-slot{border:1.5px solid #e2e8e4;border-radius:100px;background:#fff;padding:10px 18px;font:inherit;font-weight:700;font-size:14.5px;cursor:pointer;text-align:center;transition:border-color .12s}",
    ".sep-slot:hover{border-color:#28282c}",
    ".sep-slot small{display:block;font-weight:600;font-size:10.5px;color:#8a948e;margin-top:2px}",
    ".sep-slot.low small{color:#b45309}",
    ".sep-slot[aria-pressed=true]{border-color:#28282c;background:#f5f5f4;color:#28282c}",
    ".sep-more{border:none;background:none;color:#28282c;font-weight:700;font-size:13px;cursor:pointer;padding:12px 2px 2px;text-decoration:underline;text-underline-offset:3px;font-family:inherit}",
    ".sep-months{display:flex;gap:18px}",
    ".sep-month{flex:1;min-width:0}",
    "@media(max-width:560px){.sep-months{flex-direction:column}}",
    ".sep-grid-wrap{margin-top:10px;border:1px solid #e5eae6;border-radius:14px;padding:14px}",
    ".sep-cal-nav{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}",
    ".sep-cal-nav button{border:1px solid #dfe5e1;background:#fff;border-radius:8px;width:30px;height:30px;cursor:pointer;font:inherit}",
    ".sep-cal-nav button:disabled{opacity:.3;cursor:default}",
    ".sep-mtitle{text-align:center;font-size:13.5px;font-weight:700;margin:0 0 6px}",
    ".sep-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:3px}",
    ".sep-dow{text-align:center;font-size:10px;color:#a9b2ac;font-weight:700;text-transform:uppercase;padding:2px 0}",
    ".sep-gd{aspect-ratio:1;border:none;background:none;border-radius:9px;font:inherit;font-size:13px;color:#c4cbc6;display:grid;place-items:center}",
    ".sep-gd.has{color:#17201c;font-weight:700;background:#f4f4f2;cursor:pointer}",
    ".sep-gd.has:hover{background:#e8e8e5}",
    ".sep-gd.low{background:#fdf3e3}",
    ".sep-gd.sel{background:#28282c!important;color:#fff}",
    ".sep-confirm{margin-top:14px;border:1.5px solid #28282c;background:#f5f5f4;border-radius:13px;padding:14px 16px}",
    ".sep-confirm-line{display:flex;align-items:center;gap:8px;font-weight:700;font-size:14px}",
    ".sep-hold{font-size:11.5px;color:#4e5c55;font-weight:500;margin:3px 0 0}",
    ".sep-q{display:block;margin-top:11px;font-size:12.5px;font-weight:700;color:#334}",
    ".sep-q input{width:100%;font:inherit;font-weight:400;padding:9px 11px;border:1.5px solid #cfd8d2;border-radius:9px;margin-top:4px;background:#fff;box-sizing:border-box}",
    ".sep-cta{width:100%;margin-top:12px;background:#f94d00;color:#fff;border:none;border-radius:100px;padding:14px;font:inherit;font-weight:700;font-size:15px;cursor:pointer}",
    ".sep-cta:hover{background:#e84900}",
    ".sep-err{color:#9c3a2e;font-size:13px;margin:8px 0 0}",
    ".sep-empty{color:#4e5c55;font-size:14px;padding:8px 0}",
  ].join("\n");

  function injectCss() {
    if (document.getElementById("sep-css")) return;
    var st = document.createElement("style");
    st.id = "sep-css"; st.textContent = CSS;
    document.head.appendChild(st);
  }

  function group(sessions) {
    var by = {};
    sessions.forEach(function (s) { (by[s.local_date] = by[s.local_date] || []).push(s); });
    return by;
  }

  window.SEPicker = {
    mount: function (root, data, opts) {
      injectCss();
      opts = opts || {};
      var sessions = data.sessions || [];
      var byDate = group(sessions);
      var availDates = Object.keys(byDate).filter(function (d) {
        return byDate[d].some(function (s) { return s.seats_available > 0; });
      }).sort();
      var state = { day: null, session: null, gridOpen: false, gridMonth: null };

      if (!availDates.length) {
        root.innerHTML = '<p class="sep-empty">No upcoming dates right now — check back soon, or contact us for private bookings.</p>';
        if (opts.onEmpty) opts.onEmpty();
        return;
      }
      if (opts.autoSelectDay !== false) state.day = availDates[0];

      function labelFor(iso) {
        var d = new Date(iso + "T12:00:00");
        var today = new Date(); today.setHours(12, 0, 0, 0);
        var diff = Math.round((d - today) / 86400000);
        var dow = d.toLocaleDateString("en-US", { weekday: "short" });
        var num = d.getDate();
        var mon = d.toLocaleDateString("en-US", { month: "short" });
        return { top: diff === 0 ? "Today" : diff === 1 ? "Tmrw" : dow, big: String(num), sub: mon };
      }

      function render() {
        var selLabel = state.day ? new Date(state.day + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" }) : null;
        var html = '<div class="sep">' +
          '<div class="sep-head"><p class="sep-title">Pick your date</p>' +
          '<span class="sep-count">' + availDates.length + " dates available</span></div>";
        if (opts.layout === "months") {
          html += '<div id="sep-grid"></div>';
        } else {
          html += '<div class="sep-striprow"><button type="button" class="sep-pad prev" aria-label="Earlier dates">‹</button>' +
            '<div class="sep-strip" role="listbox" aria-label="Available dates">';
          availDates.slice(0, 28).forEach(function (d) {
            var l = labelFor(d);
            var spots = byDate[d].reduce(function (a, s) { return a + Math.max(s.seats_available, 0); }, 0);
            html += '<button type="button" class="sep-day" role="option" aria-pressed="' + (state.day === d) + '" data-d="' + d + '">' +
              "<span>" + l.top + "</span><b>" + l.big + "</b><i>" + l.sub + "</i>" +
              (spots <= 6 ? "<em>" + spots + " left</em>" : "") + "</button>";
          });
          html += '</div><div class="sep-fade"></div><button type="button" class="sep-pad next" aria-label="Later dates">›</button></div>';
        }
        html += (selLabel ? '<p class="sep-times-label" style="margin-top:10px">Times for ' + selLabel + "</p>" : "");
        html += '<div class="sep-slots" id="sep-slots"></div>';
        if (opts.layout !== "months") {
          html += '<button type="button" class="sep-more" id="sep-more">' + (state.gridOpen ? "Hide calendar ▴" : "Browse all dates ▾") + '</button><div id="sep-grid-inline"></div>';
        }
        html += '<div id="sep-sel"></div></div>';
        root.innerHTML = html;

        root.querySelectorAll(".sep-day").forEach(function (b) {
          b.addEventListener("click", function () { state.day = b.dataset.d; state.session = null; render(); });
        });
        var strip = root.querySelector(".sep-strip");
        if (strip) {
          var sel = strip.querySelector('[aria-pressed="true"]');
          if (sel) sel.scrollIntoView({ block: "nearest", inline: "center" });
          root.querySelectorAll(".sep-pad").forEach(function (p) {
            p.addEventListener("click", function () {
              strip.scrollBy({ left: p.classList.contains("next") ? 280 : -280, behavior: "smooth" });
            });
          });
        }
        var more = root.querySelector("#sep-more");
        if (more) more.addEventListener("click", function () { state.gridOpen = !state.gridOpen; render(); });
        renderSlots();
        if (opts.layout === "months") renderGrid(root.querySelector("#sep-grid"), 2);
        else if (state.gridOpen) renderGrid(root.querySelector("#sep-grid-inline"), 1);
        renderSel();
      }

      function renderSlots() {
        var el = root.querySelector("#sep-slots");
        if (!state.day) { el.innerHTML = ""; return; }
        el.innerHTML = (byDate[state.day] || []).map(function (s) {
          var full = s.seats_available < 1, low = !full && s.seats_available <= 3;
          return '<button type="button" class="sep-slot' + (low ? " low" : "") + '" data-id="' + s.id + '"' +
            (full ? " disabled style='opacity:.4;cursor:default'" : "") +
            ' aria-pressed="' + (state.session && state.session.id === s.id) + '">' + s.local_time +
            "<small>" + (full ? "sold out" : s.seats_available + " left") + "</small></button>";
        }).join("");
        el.querySelectorAll(".sep-slot:not([disabled])").forEach(function (b) {
          b.addEventListener("click", function () {
            state.session = sessions.find(function (s) { return s.id === b.dataset.id; });
            render();
            var sel = root.querySelector(".sep-confirm");
            if (sel) sel.scrollIntoView({ behavior: "smooth", block: "nearest" });
          });
        });
      }

      function renderGrid(target, count) {
        if (!target) return;
        var months = [];
        availDates.forEach(function (d) { var m = d.slice(0, 7); if (months.indexOf(m) < 0) months.push(m); });
        if (!state.gridMonth || months.indexOf(state.gridMonth) < 0) {
          state.gridMonth = (state.day || availDates[0]).slice(0, 7);
        }
        var mi = months.indexOf(state.gridMonth);
        if (count > 1 && mi > months.length - count) mi = Math.max(0, months.length - count);
        var shown = months.slice(mi, mi + count);
        var html = '<div class="sep-grid-wrap"><div class="sep-cal-nav">' +
          '<button type="button" data-nav="-1"' + (mi <= 0 ? " disabled" : "") + ' aria-label="Earlier">‹</button>' +
          '<span style="font-size:12px;color:#8a948e;font-weight:600">' + (count > 1 ? "Next two months" : "") + "</span>" +
          '<button type="button" data-nav="1"' + (mi + count >= months.length ? " disabled" : "") + ' aria-label="Later">›</button></div>' +
          '<div class="sep-months">';
        shown.forEach(function (mkey) {
          var first = new Date(mkey + "-01T12:00:00");
          var lead = first.getDay();
          var dim = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
          html += '<div class="sep-month"><p class="sep-mtitle">' +
            first.toLocaleDateString("en-US", { month: "long", year: "numeric" }) + "</p>" +
            '<div class="sep-grid">' +
            ["S", "M", "T", "W", "T", "F", "S"].map(function (d) { return '<span class="sep-dow">' + d + "</span>"; }).join("");
          for (var i = 0; i < lead; i++) html += "<span></span>";
          for (var day = 1; day <= dim; day++) {
            var key = mkey + "-" + String(day).padStart(2, "0");
            var ss = byDate[key] || [];
            var spots = ss.reduce(function (a, s) { return a + Math.max(s.seats_available, 0); }, 0);
            var has = spots > 0, low = has && spots <= 6;
            html += '<button type="button" class="sep-gd' + (has ? " has" : "") + (low ? " low" : "") +
              (key === state.day ? " sel" : "") + '"' + (has ? ' data-d="' + key + '"' : " disabled tabindex='-1'") + ">" + day + "</button>";
          }
          html += "</div></div>";
        });
        html += "</div></div>";
        target.innerHTML = html;
        target.querySelectorAll("[data-nav]").forEach(function (b) {
          b.addEventListener("click", function () {
            state.gridMonth = months[Math.min(Math.max(mi + Number(b.dataset.nav), 0), months.length - 1)];
            render();
          });
        });
        target.querySelectorAll(".sep-gd.has").forEach(function (b) {
          b.addEventListener("click", function () { state.day = b.dataset.d; state.session = null; render(); });
        });
      }

      function renderSel() {
        var el = root.querySelector("#sep-sel");
        if (!state.session) { el.innerHTML = ""; if (opts.onClear) opts.onClear(); return; }
        var s = state.session;
        var qs = (data.experience && data.experience.intake_questions) || [];
        var html = '<div class="sep-confirm"><div class="sep-confirm-line">✓ ' + s.local_label +
          (s.venue ? " · " + s.venue : "") + "</div>" +
          '<p class="sep-hold">Your spot is held for 15 minutes while you check out.</p>';
        qs.forEach(function (q, i) {
          html += '<label class="sep-q">' + q.label +
            '<input type="text" data-qi="' + i + '" placeholder="' + (q.required ? "Required" : "Optional") + '"></label>';
        });
        if (opts.confirmLabel) html += '<button type="button" class="sep-cta" id="sep-cta">' + opts.confirmLabel + "</button>";
        html += "</div>";
        el.innerHTML = html;
        var answers = function () {
          var out = {};
          el.querySelectorAll("[data-qi]").forEach(function (inp) {
            var q = qs[Number(inp.dataset.qi)];
            if (inp.value.trim()) out[q.label] = inp.value.trim();
          });
          return out;
        };
        if (opts.confirmLabel) {
          el.querySelector("#sep-cta").addEventListener("click", function () { opts.onConfirm(s, answers()); });
        } else if (opts.onConfirm) {
          opts.onConfirm(s, answers);  // live mode: pass a getter, caller reads at submit time
        }
      }

      render();
    },
  };
})();
